import { Directive, ElementRef, EventEmitter, Output, OnInit } from '@angular/core';

declare const google: any; // Declare the Google object globally

@Directive({
  selector: '[googlePlace]'
})
export class GooglePlaceDirective implements OnInit {
  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  private element: HTMLInputElement;

  constructor(private elRef: ElementRef) {
    this.element = this.elRef.nativeElement;
  }

  ngOnInit(): void {
    // Check if Google API is loaded
    if (typeof google === 'undefined' || !google.maps) {
      console.error('Google Maps API is not loaded');
      return;
    }

    // Initialize Google Places Autocomplete
    const autocomplete = new google.maps.places.Autocomplete(this.element, {
      types: ['geocode'], 
    });

    // Listen for place selection
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      this.onSelect.emit(place); // Emit selected place details
    });

  }
}
